module.exports = __webpack_public_path__ + "img/wagon.4109ec63.svg";